package com.anjuros.website.templates.template1.styles

import com.anjuros.website.templates.template1.modules.Template1Theme
import com.anjuros.website.templates.template1.modules.getColor
import com.anjuros.website.templates.template1.util.Template1Constants
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.StyleVariable
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.argb
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.rotate
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba

val CompanyColorVar by StyleVariable<CSSColorValue>()

val Template1MenuBackgroundStyle = CssStyle{
    base { Modifier.fillMaxSize()
        .objectFit(ObjectFit.Cover)
        .height(400.px).margin(top=60.px)}
    Breakpoint.MD { Modifier.fillMaxSize()
        .objectFit(ObjectFit.Cover)
        .height(600.px)   .margin(top=60.px)}
    Breakpoint.LG  { Modifier.fillMaxSize()
        .objectFit(ObjectFit.Cover)
        .height(700.px)   .margin(top=60.px)}
    Breakpoint.XL { Modifier.fillMaxSize()
        .objectFit(ObjectFit.Cover)
        .height(700.px)
        .margin(top=60.px)}
}

val Template1NavigationItemStyle = CssStyle {
    base {
        Modifier
            .color(Template1Theme.Secondary.rgb)
            .transition(Transition.of(property = "color", duration = 200.ms))
    }
    hover {
        Modifier
            .color(CompanyColorVar.value())
    }
}

val Template1NavigationFooterItemStyle = CssStyle {
    base {
        Modifier
            .color(Colors.White)
            .transition(Transition.of(property = "color", duration = 200.ms))
    }
    hover {
        Modifier
            .color(CompanyColorVar.value())
    }
}

val Template1AboutColumnWidthStyle = CssStyle {
    base { Modifier.fillMaxWidth(90.percent) }
    Breakpoint.MD { Modifier.fillMaxWidth(90.percent) }
    Breakpoint.LG { Modifier.fillMaxWidth(80.percent) }
    Breakpoint.XL { Modifier.fillMaxWidth(80.percent)}
}

val Template1FooterColumnWidthStyle = CssStyle {
    base { Modifier.fillMaxWidth(90.percent) }
    Breakpoint.MD { Modifier.fillMaxWidth(100.percent) }
    Breakpoint.LG { Modifier.fillMaxWidth(100.percent) }
    Breakpoint.XL { Modifier.fillMaxWidth(100.percent)}
}

val Template1PriceColorStyle = CssStyle {

    base {
        Modifier
            .backgroundColor(Colors.Transparent)
            .transition(Transition.of(property = "backgroundColor", duration = 100.ms))
    }
    hover {
        Modifier
            .backgroundColor(argb(a=0.2f,r=255.0f,g=255.0f,b=255.0f))
    }
}
val Template1ReviewStyle = CssStyle {

    Breakpoint.ZERO { Modifier.margin(right=0.px, bottom = 40.px) }
    Breakpoint.SM { Modifier.margin(right=0.px, bottom = 40.px) }
    Breakpoint.MD { Modifier.margin(right=40.px, bottom = 40.px) }
    Breakpoint.LG { Modifier.margin(right=40.px, bottom = 0.px) }
    Breakpoint.XL { Modifier.margin(right=40.px, bottom = 0.px) }
}

val Template1CallButton = CssStyle {

    base {
        Modifier
            .transition(Transition.of("all", 300.ms))
    }

    hover {
        Modifier
            .transform { translateY((-4).px) }

    }
}

val Template1ContactStyle = CssStyle {

    base {
        Modifier
            .color(Colors.White)
            .transition(Transition.of("color", 300.ms))
    }

    hover {
        Modifier
            .color(Template1Theme.Primary.rgb)

    }
}

val Template1SectionTitleStyle = CssStyle {
    base { Modifier.fontSize(34.px) }
    Breakpoint.MD { Modifier .fontSize(40.px) }
    Breakpoint.LG { Modifier .fontSize(52.px) }
    Breakpoint.XL { Modifier .fontSize(52.px)}
}

val Template1HeroFontSizeStyle = CssStyle {
    base { Modifier.fontSize(34.px) }
    Breakpoint.MD { Modifier .fontSize(48.px) }
    Breakpoint.LG { Modifier .fontSize(72.px)
        .lineHeight(82.px) }
    Breakpoint.XL { Modifier .fontSize(72.px)
        .lineHeight(82.px)}
}

val Template1HeroHeaderStyle = CssStyle {
    base { Modifier.padding(
        top = 50.px,
        bottom = 0.px
    ) }
    Breakpoint.MD { Modifier .padding(
        top = 50.px,
        bottom = 0.px
    ) }
    Breakpoint.LG { Modifier .padding(
        top = 180.px,
        bottom = 110.px
    ) }
    Breakpoint.XL { Modifier .padding(
        top = 180.px,
        bottom = 110.px
    )}
}

val Template1GalleryItemShadowStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .boxShadow(
                offsetY = 8.px,
                blurRadius = 25.px,
                color = rgba(0, 0, 0, 0.4)
            )
            .transition(Transition.of(property = "boxShadow", duration = 200.ms))
            .transition(
                Transition.of(
                    "translateY",
                    500.ms
                )
            )
    }
    hover {
        Modifier
            .translateY((-5).px)
            .boxShadow(
                offsetY = 8.px,
                blurRadius = 20.px,
                color = rgba(0, 0, 0, 0.8)
            )
    }
    // Up to 350px, but never wider than its grid column (minus the 10px margin each side).
    Breakpoint.MD { Modifier.styleModifier { property("width", "min(350px, calc(100% - 20px))") } }
}

val Template1ContactFormStyle = CssStyle {
    base { Modifier.margin(top=50.px, leftRight = 20.px) }
    Breakpoint.MD { Modifier.margin(top=50.px, leftRight = 20.px) }
    Breakpoint.LG { Modifier .margin(0.px) }
    Breakpoint.XL { Modifier  .margin(0.px)}
}

val Template1SectionPaddingStyle = CssStyle {
    base { Modifier  .padding(topBottom = 75.px)}
    Breakpoint.MD { Modifier  .padding(topBottom = 100.px)}
    Breakpoint.LG { Modifier  .padding(topBottom = 125.px)}
    Breakpoint.XL { Modifier   .padding(topBottom = 125.px)}
}
